import AfternoonIcon from "/src/assets/images/common/afternoon.inline.svg";
import MorningIcon from "/src/assets/images/common/morning.inline.svg";
import NightIcon from "/src/assets/images/common/night.inline.svg";

import { HeadFC, PageProps, graphql } from "gatsby";
import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Container, Pagination, Row } from "react-bootstrap";
import NationalIcon from "~/assets/images/common/input-chip.inline.svg";
import {
	Introduction,
	MultiColumnImage,
	OneColumnSlider,
	Page,
	ProgramCard,
	ReviewCard,
	Section,
	TwoColumnImageExtended,
	TwoColumnMapiFrame,
} from "~/components";
import SEO from "~/components/shared/seo/seo";
import fetchProgramData from "~/utils/fetchProgramData";

/* Section Data */

const heroSectionData = {
	visible: true,
	variant: "1",
	paddingTop: "2rem",
	paddingBottom: "0",
};

const navSectionData = {
	visible: true,
	variant: "4",
	paddingTop: "2rem",
	paddingBottom: "2rem",
};

const programSliderSectionData = {
	visible: true,
	variant: "3",
	paddingTop: "4rem",
	paddingBottom: "2rem",
};

const scheduleSectionData = {
	visible: true,
	variant: "1",
	paddingTop: "2rem",
	paddingBottom: "2rem",
};

const reviewSectionData = {
	visible: true,
	variant: "1",
	paddingTop: "4rem",
	paddingBottom: "4rem",
};

const featuresSectionData = {
	visible: true,
	variant: "1",
	paddingTop: "4rem",
	paddingBottom: "4rem",
};

const ctaSectionData = {
	visible: true,
	variant: "1",
	paddingTop: "4rem",
	paddingBottom: "",
};
/** Component Data */

const navPillData = [
	{
		id: "2a1fc8bd-a71c-4e4f-98f6-e458eefc7210",
		title: "National Online",
		linkTo: "/online-it-training/",
	},
	{
		id: "b887f574-6621-41c0-a4da-7b14e0cd2415",
		title: "Colorado Springs, CO",
		linkTo: "/it-training-near-me-colorado-springs/",
	},
	{
		id: "9a446d0d-624b-41d5-ae7e-1fe774a0e704",
		title: "Dallas, TX",
		linkTo: "/it-training-near-me-dallas/",
	},
	{
		id: "29d7dcac-89e9-45b5-a210-257f66ca8180",
		title: "San Antonio, TX",
		linkTo: "/it-training-near-me-san-antonio/",
	},
];

const programSliderIntroData = {
	id: "33ef1125-097c-43c5-8a36-6921d08cb4c7",
	preTitleTag: "",
	preTitleTagClassNames: "",
	preTitle: "",
	preTitleClassNames: "",
	title: "Programs offered",
	titleTag: "h2",
	titleClassNames: "h4",
	content: "",
	buttonId: null,
	buttonLabel: "",
	buttonUrl: null,
	buttonVariant: "",
	buttonAriaLabel: "",
	buttonOpenInNewTab: false,
	buttonSecondaryId: null,
	buttonSecondaryLabel: "",
	buttonSecondaryUrl: null,
	buttonSecondaryVariant: "",
	buttonSecondaryAriaLabel: "",
	buttonSecondaryOpenInNewTab: false,
	buttonOnClick: null,
	featureListItems: null,
	buttonIcon: false,
	buttonSecondaryIcon: false,
};

const programSliderData = {
	className: "slider",
	dots: false,
	arrows: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	infinite: false,
	centerMode: undefined,
};

const programsData = [
	{
		id: "de1bad0a-9b87-4935-8c07-65e33f8b67ee",
		variant: "2",
		title: "Computer User Support Specialist",
		level: "Entry Level",
		duration: "11 weeks",
		buttonAriaLabel: "view program details",
		buttonId: "program-card-cta",
		buttonLabel: "View program",
		buttonOpenInNewTab: false,
		buttonUrl:
			"/training/itil-comptia-computer-user-support-specialist-cuss/",
		buttonVariant: "sandbox-sun-primary",
	},
	{
		id: "64ba3e52-ab47-4fff-b198-e2fea7418bde",
		variant: "2",
		title: "IT Support Specialist",
		level: "Entry Level",
		duration: "5 weeks",
		buttonAriaLabel: "view program details",
		buttonId: "program-card-cta",
		buttonLabel: "View program",
		buttonOpenInNewTab: false,
		buttonUrl: "/training/it-support-specialist-program/",
		buttonVariant: "sandbox-sun-primary",
	},
	// {
	// 	id: "82a087ce-9727-4e8a-9927-9d95f9173287",
	// 	variant: "2",
	// 	title: "Information Security Analyst",
	// 	level: "Intermediate Level",
	// 	duration: "6 weeks",
	// 	buttonAriaLabel: "view program details",
	// 	buttonId: "program-card-cta",
	// 	buttonLabel: "View program",
	// 	buttonOpenInNewTab: false,
	// 	buttonUrl: "/training/information-security-analyst-isa/",
	// 	buttonVariant: "sandbox-sun-primary",
	// },
	{
		id: "171d414b-fe9c-42e7-9999-a8e774087f01",
		variant: "2",
		title: "Cyber Security Analyst",
		level: "Intermediate Level",
		duration: "7 weeks",
		buttonAriaLabel: "view program details",
		buttonId: "program-card-cta",
		buttonLabel: "View program",
		buttonOpenInNewTab: false,
		buttonUrl: "/training/cybersecurity-analyst-csa/",
		buttonVariant: "sandbox-sun-primary",
	},
	// {
	// 	id: "0173c252-d184-4619-9067-402b75ad740d",
	// 	variant: "2",
	// 	title: "Network Support Specialist",
	// 	level: "Intermediate Level",
	// 	duration: "8 weeks",
	// 	buttonAriaLabel: "view program details",
	// 	buttonId: "program-card-cta",
	// 	buttonLabel: "View program",
	// 	buttonOpenInNewTab: false,
	// 	buttonUrl: "/training/network-support-specialist-nss/",
	// 	buttonVariant: "sandbox-sun-primary",
	// },
	{
		id: "7dd78f7a-3e7e-4f8c-a471-3463a4b296e6",
		variant: "2",
		title: "Network Technician",
		level: "Intermediate Level",
		duration: "5 weeks",
		buttonAriaLabel: "view program details",
		buttonId: "program-card-cta",
		buttonLabel: "View program",
		buttonOpenInNewTab: false,
		buttonUrl: "/training/network-technician-program/",
		buttonVariant: "sandbox-sun-primary",
	},
];

const reviewIntroData = {
	id: "3a3139e8-7d44-40c9-b097-3ab5e85929fc",
	preTitleTag: "",
	preTitleTagClassNames: "",
	preTitle: "student testimonials",
	preTitleClassNames: "label-standout-sm",
	title: "Hear from our alumni<span class='text-sandbox-sun-primary' aria-hidden='true'>.</span>",
	titleTag: "h2",
	titleClassNames: "h3",
	content: "",
	buttonId: null,
	buttonLabel: "",
	buttonUrl: null,
	buttonVariant: "",
	buttonAriaLabel: "",
	buttonOpenInNewTab: false,
	buttonSecondaryId: null,
	buttonSecondaryLabel: "",
	buttonSecondaryUrl: null,
	buttonSecondaryVariant: "",
	buttonSecondaryAriaLabel: "",
	buttonSecondaryOpenInNewTab: false,
	buttonOnClick: null,
	featureListItems: null,
	buttonIcon: false,
	buttonSecondaryIcon: false,
};

const reviewContent = [
	{
		id: "5e389618-a6f3-4975-bdb0-0b86ec0beb19",
		comment:
			"This was a rigorous and difficult course, but it was fun, challenging and full of valuable information. I applaud Paul Herbka who is an outstanding instructor and teacher. Without him teaching this course I am confident it would have been far more difficult.",
		course: "EC-Council Certified Ethical Hacker (CEHv12)",
		date: null,
		name: "Branden J.",
	},
	{
		id: "560db032-7be1-450f-9a56-24ec13f7159c",
		comment:
			"I came in a little skeptical about this course and thought that it was a waste of time. By the end of day one I realized how glad I was to be in this class because of Professor Jack Quinn. He is really knowledgeable and had more than enough good pointers. His commitment level to our success is beyond impressive. I am happy to have worked with this Jack Quinn.",
		course: "EC-Council Certified Ethical Hacker (CEHv12)",
		date: null,
		name: "Alejandro C.",
	},
	{
		id: "09a9c1fe-257f-4d9e-81ff-8a700ce5c5f9",
		comment:
			"This course was just phenomenal. I had my doubts, but the instructors really make this experience amazing. Put your effort into it, just as they do, and I can promise you will do great. I came in with VERY minimal IT knowledge, and right now I'm about to interview for an associate NOC position. It's crazy!!",
		course: "CompTIA Security+ 601 (2.0)",
		date: null,
		name: "Jesse P.",
	},
];

const featuresIntroData = {
	id: "41a4f86b-e67a-4e10-80e3-6ecc93f446b5",
	preTitleTag: "",
	preTitleTagClassNames: "",
	preTitle: "aci tech academy",
	preTitleClassNames: "label-standout-sm",
	title: "Features of all programs<span class='text-sandbox-sun-primary' aria-hidden='true'>.</span>",
	titleTag: "h2",
	titleClassNames: "h3",
	content: "",
	buttonId: null,
	buttonLabel: "",
	buttonUrl: null,
	buttonVariant: "",
	buttonAriaLabel: "",
	buttonOpenInNewTab: false,
	buttonSecondaryId: null,
	buttonSecondaryLabel: "",
	buttonSecondaryUrl: null,
	buttonSecondaryVariant: "",
	buttonSecondaryAriaLabel: "",
	buttonSecondaryOpenInNewTab: false,
	buttonOnClick: null,
	featureListItems: null,
	buttonIcon: false,
	buttonSecondaryIcon: false,
};

const ctaData = {
	id: "f5ac7404-207f-46df-85cd-aaeb8040ddef",
	visible: true,
	variant: "1",
	containerFluid: false,
	paddingTop: "2rem",
	paddingBottom: "2rem",
	marginTop: "",
	marginBottom: "",
	paddingLeft: "",
	paddingRight: "",
	logo: null,
	highlighted: "",
	imageLeft: true,
	imageFluid: false,
	componentMinHeight: "",
	imageRowAlignment: "bottom",
	contentRowAlignment: "middle",
	imageCaption: "",
	imageClasses: null,
	image: {
		alternativeText: "pensive man using computer",
		localFile: {
			url: "https://aci-dev-strapi-bucket.s3.amazonaws.com/cta_image_4829054041.png",
			childImageSharp: null,
		},
	},
	hideImageOnMobile: false,
	introductionData: {
		id: "3bfc9a82-4b45-438f-8af6-a2052572a133",
		preTitleTag: "",
		preTitleTagClassNames: "",
		preTitle: "",
		preTitleClassNames: "",
		title: "Propel your IT career<span class='text-sandbox-sun-primary' aria-hidden='true'>.</span>",
		titleTag: "h2",
		titleClassNames: "h3",
		content:
			// eslint-disable-next-line max-len
			"After you complete the form, you’ll be contacted to reserve a tour time that fits your schedule. Or call our Colorado Springs Tech Academy any time to schedule a visit.",
		buttonLabel: "Schedule a consultation",
		buttonId: null,
		buttonUrl: "#contact-form",
		buttonVariant: "secondary",
		buttonAriaLabel: "open form in modal",
		buttonOpenInNewTab: false,
		buttonSecondaryId: null,
		buttonSecondaryLabel: "",
		buttonSecondaryUrl: null,
		buttonSecondaryVariant: "",
		buttonSecondaryAriaLabel: "",
		buttonSecondaryOpenInNewTab: false,
		buttonOnClick: null,
		featureListItems: null,
		buttonIcon: false,
		buttonSecondaryIcon: false,
	},
};

const nationalAcademyData = {
	id: "bc397a0c-53a5-49e6-807f-d19cff1bae1c",
	visible: true,
	variant: "1",
	containerFluid: false,
	paddingTop: "4rem",
	paddingBottom: "4rem",
	marginTop: "",
	marginBottom: "",
	paddingLeft: "",
	paddingRight: "",
	logo: {
		alternativeText: "network icon",
		localFile: {
			url: "https://aci-dev-strapi-bucket.s3.amazonaws.com/network_a064e1624c.svg",
			childImageSharp: null,
		},
	},
	highlighted: "",
	imageLeft: true,
	imageFluid: false,
	componentMinHeight: "",
	imageRowAlignment: "bottom",
	contentRowAlignment: "middle",
	imageCaption: "",
	iamgeClasses: "",
	image: {
		alternativeText:
			"two professional women examining a tablet with webpage graphics in forground",
		localFile: {
			url: "https://aci-dev-strapi-bucket.s3.amazonaws.com/career_support_26ccd30624.png",
			childImageSharp: null,
		},
	},
	hideImageOnMobile: false,
	introductionData: {
		id: "5b07b924-bae0-4585-8b49-a1128f07d684",
		preTitleTag: "",
		preTitleTagClassNames: "",
		preTitle: "",
		preTitleClassNames: "",
		title: "1-on-1 career support and job placement",
		titleTag: "h2",
		titleClassNames: "h3",
		content:
			// eslint-disable-next-line max-len
			"Get personalized 1-on-1 career support and job placement assistance, tailored to launch and elevate your career in IT and cybersecurity. Whether you’re just getting a job, or looking for a new one, we’re here for you.",
		buttonLabel: "Career Services",
		buttonId: null,
		buttonUrl: "/information-technology-career-services/",
		buttonVariant: "outline-secondary",
		buttonAriaLabel: "",
		buttonOpenInNewTab: false,
		buttonSecondaryId: null,
		buttonSecondaryLabel: "",
		buttonSecondaryUrl: null,
		buttonSecondaryVariant: "",
		buttonSecondaryAriaLabel: "",
		buttonSecondaryOpenInNewTab: false,
		buttonOnClick: null,
		featureListItems: null,
		buttonIcon: false,
		buttonSecondaryIcon: false,
	},
};

/** Schedule Data */

const slugToLocationInformation = {
	"it-training-near-me-colorado-springs": {
		location: "Colorado Springs Learning Hub",
		timezone: "MT",
	},
	"it-training-near-me-dallas": {
		location: "Dallas Learning Hub",
		timezone: "CT",
	},
	"it-training-near-me-san-antonio": {
		location: "San Antonio Learning Hub",
		timezone: "CT",
	},
	"online-it-training": {
		location: "National Learning Hub",
		timezone: "CT",
	},
};

// RECORDS_PER_PAGE is how many programs are shown at once on each page
const RECORDS_PER_PAGE = 5;
// This is the max number of elements we want in the pagination component, including controls (prev / next / ...)
const MAX_PIPS = 5;

/** Component */

const HubPage: React.FC<PageProps<Queries.HubPageQuery>> = ({ data }) => {
	const { queryData } = data;
	const isNationalHub = queryData?.slug === "online-it-training";
	const [programCardData, setProgramCardData] = useState(programsData);

	useMemo(() => {
		if (isNationalHub) {
			const newData = programsData.filter(
				(item) => item.title !== "Computer User Support Specialist",
			);
			console.log(newData);
			setProgramCardData(newData);
		} else {
			const newData = programsData.filter(
				(item) => item.title !== "Cyber Security Analyst",
			);

			setProgramCardData(newData);
		}
	}, []);

	const renderNavPills = useMemo(() => {
		return navPillData.map((item) => {
			const isNationalHub = item.title === "National Online";
			const formattedSlug = "/" + queryData?.slug + "/";
			return (
				<a
					href={item.linkTo}
					rel="noreferrer"
					target="_self"
					key={item.id}
					className={`nav-pill me-3 p-2 mb-2${
						item.linkTo === formattedSlug ? " active" : ""
					}`}
				>
					{isNationalHub && <NationalIcon />}
					{item.title}
				</a>
			);
		});
	}, [navPillData]);

	const renderProgramCards = useMemo(() => {
		return programCardData?.map((item, index) => {
			return <ProgramCard data={item} key={index} />;
		});
	}, [programCardData]);

	const renderReviews = useMemo(() => {
		return reviewContent.map((item, index) => {
			return (
				<Col
					md={4}
					key={index}
					className="d-flex justify-content-center full-width pb-5 pb-lg-0"
				>
					<ReviewCard data={item} />
				</Col>
			);
		});
	}, [reviewContent]);

	const locationInformation = slugToLocationInformation[queryData?.slug];

	// programData is the raw array data that has been returned from the API call to SFDC
	const [programData, setProgramData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);

	useEffect(() => {
		fetchProgramData().then((data) => setProgramData(data));
	}, []);

	const filteredData = useMemo(() => {
		const newData = [];
		programData.forEach((program) => {
			if (program.Location === locationInformation.location) {
				newData.push(program);
			}
		});
		return newData;
	}, [programData]);

	const sortedData = useMemo(() => {
		const newData = filteredData.sort((a, b) => {
			return a.StartDateTime - b.StartDateTime;
		});
		return newData;
	}, [filteredData]);

	const visibleData = useMemo(() => {
		const firstIndex = (currentPage - 1) * RECORDS_PER_PAGE;
		const lastIndex = currentPage * RECORDS_PER_PAGE;
		return sortedData.slice(firstIndex, lastIndex);
	}, [sortedData, currentPage, RECORDS_PER_PAGE]);

	const numPages = useMemo(() => {
		return Math.ceil(filteredData.length / RECORDS_PER_PAGE);
	}, [filteredData, RECORDS_PER_PAGE]);

	const scheduleIntroData = {
		id: "f956af4f-9e51-4141-ab86-5ae5baca30ff",
		preTitleTag: "",
		preTitleTagClassNames: "",
		preTitle: `${slugToName(queryData?.slug ?? "")} schedule`,
		preTitleClassNames: "label-standout-sm",
		title: "Upcoming training",
		titleTag: "h2",
		titleClassNames: "h3",
		content:
			"Whether you have a full-time job or other commitments, our training programs are designed with convenience in mind, offering flexible scheduling options in the morning, afternoon, or evening.",
		buttonId: null,
		buttonLabel: "Get started",
		buttonUrl: "#contact-form",
		buttonVariant: "secondary",
		buttonAriaLabel: "open form in modal",
		buttonOpenInNewTab: false,
		buttonSecondaryId: null,
		buttonSecondaryLabel: null,
		buttonSecondaryUrl: null,
		buttonSecondaryVariant: null,
		buttonSecondaryAriaLabel: null,
		buttonSecondaryOpenInNewTab: false,
		buttonOnClick: null,
		featureListItems: null,
		buttonIcon: false,
		buttonSecondaryIcon: false,
	};

	const renderPrograms = useMemo(() => {
		if (visibleData.length === 0) {
			return (
				<Row key="no data" className="py-2">
					<Col lg={12}>
						<div>Check back soon for upcoming training</div>
					</Col>
				</Row>
			);
		}
		return visibleData.map((item, index) => {
			const renderProgramTimes = [];
			const programTimes = item.ProgramTimes;
			for (let i = 0; i < programTimes.length; i++) {
				renderProgramTimes.push(
					<div className="d-flex align-items-center">
						<span className="time-icon pe-1 d-none d-lg-block">
							{renderTimeIcon(programTimes[i].StartTimeFormatted)}
						</span>
						<div className="dates" key={Math.random()}>
							{/* {programTimes[i].DayType}{" "} */}
							{programTimes[i].StartTimeFormatted}
							{" \u2013 "}
							{programTimes[i].EndTimeFormatted} {item.TimeZone}
						</div>
					</div>,
				);
			}
			const formattedMode =
				item.Mode === "ONSITE" ? "In-person" : "Online";
			const formattedName = TANameFormatter(item.Name);
			return (
				<div key={index}>
					<Row className="py-2 d-lg-flex d-none align-items-center">
						<Col lg={4}>
							<div>
								<a
									className="mb-2"
									href={`/training${TANametoHref(item.Name)}`}
									target="_self"
								>
									{formattedName}
								</a>
								<div className="mode">{formattedMode}</div>
							</div>
						</Col>
						<Col lg={4}>
							<div className="dates">
								{item.StartDateStr}
								{" – "}
								{item.EndDateStr}
							</div>
						</Col>
						<Col lg={4}>{renderProgramTimes}</Col>
					</Row>
					<Row className="py-2 d-flex align-items-center d-lg-none">
						<Col xs={6}>
							<a
								className="mb-2"
								href={`/training${TANametoHref(item.Name)}`}
								target="_self"
							>
								{formattedName}
							</a>
							<div className="dates">
								{item.StartDateStr}
								{" – "}
								{item.EndDateStr}
							</div>
						</Col>
						<Col xs={6}>
							<div className="locations">
								{renderProgramTimes}
							</div>
						</Col>
					</Row>
				</div>
			);
		});
	}, [visibleData]);

	const renderPagination = useMemo(() => {
		if (numPages === 0) {
			return;
		} else {
			if (numPages === 1) return;
		}
		const items = [];
		items.push(
			<Pagination.Prev
				key={"prev"}
				onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
			/>,
		);
		for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
			items.push(
				<Pagination.Item
					key={pageNumber}
					active={pageNumber === currentPage}
					onClick={() => setCurrentPage(pageNumber)}
				>
					{pageNumber}
				</Pagination.Item>,
			);
		}
		items.push(
			<Pagination.Next
				key={"next"}
				onClick={() =>
					setCurrentPage(Math.min(currentPage + 1, numPages))
				}
			/>,
		);
		return (
			<Row>
				<Pagination>{items}</Pagination>
			</Row>
		);
	}, [numPages, currentPage]);

	const renderCourseCatalog = useMemo(() => {
		return (
			<Section data={scheduleSectionData}>
				<Container>
					<Row>
						<Col lg={4} xl={5} className="pe-5">
							<Introduction data={scheduleIntroData} />
						</Col>
						<Col lg={8} xl={7}>
							<Row>
								<Card className="d-flex p-3 mt-5 card-shadow">
									<Card.Body>
										<Row className="bottom-rule d-lg-flex d-none align-items-end mb-3">
											<Col lg={4}>
												<h3 className="label-standout-sm">
													Training Programs
												</h3>
											</Col>
											<Col lg={4}>
												<h3 className="label-standout-sm">
													Start/End Dates
												</h3>
											</Col>
											<Col lg={4}>
												<h3 className="label-standout-sm">
													Schedule Options
												</h3>
											</Col>
										</Row>
										<Row className="bottom-rule d-flex d-lg-none align-items-end mb-3">
											<Col xs={6}>
												<h3 className="label-standout-sm">
													Training Programs
												</h3>
												<h3 className="label-standout-sm">
													Start/End Dates
												</h3>
											</Col>
											<Col xs={6}>
												<h3 className="label-standout-sm">
													Schedule Options
												</h3>
											</Col>
										</Row>
										<div>
											<div className="program-section-location">
												{renderPrograms}
											</div>
											<div className="pt-3 pagination-section">
												{renderPagination}
											</div>
										</div>
									</Card.Body>
								</Card>
							</Row>
						</Col>
					</Row>
				</Container>
			</Section>
		);
	}, [renderPrograms, renderPagination]);

	return (
		<Page>
			<Section data={heroSectionData}>
				<TwoColumnImageExtended data={queryData?.heroData} />
			</Section>
			<Section data={navSectionData}>
				<Container>
					<Row className="padding-x">
						<Col lg={9}>
							<div>
								<h2 className="label-standout-sm mb-3">
									our training centers
								</h2>
								<div className="d-flex align-items-start flex-column flex-lg-row align-items-lg-center">
									{renderNavPills}
								</div>
							</div>
						</Col>
					</Row>
				</Container>
				<MultiColumnImage data={queryData?.galleryData} />
			</Section>
			<Section data={programSliderSectionData}>
				<Container>
					<Introduction data={programSliderIntroData} />
				</Container>
				<OneColumnSlider data={programSliderData}>
					{renderProgramCards}
				</OneColumnSlider>
			</Section>
			<Section>
				<TwoColumnMapiFrame data={queryData?.mapData} />
			</Section>
			<Section data={featuresSectionData}>
				<Container>
					<Introduction data={featuresIntroData} />
					<Row className="pt-lg-5 pt-3">
						<Col lg={4} className="mb-5">
							<h3 className="h6">Credit by ACE</h3>
							<p className="mb-0">
								All courses recommended for college credit by
								ACE.
							</p>
						</Col>
						<Col lg={4} className="mb-5">
							<h3 className="h6">VA benefits</h3>
							<p className="mb-0">
								Eligible for VA tuition benefits: (Chapter 33,
								Chapter 31, VET TEC, VRRAP, Army COOL, and more)
							</p>
							<Button
								id=""
								as="a"
								role="link"
								variant="secondary"
								href="/veteran-it-training/"
								target="_self"
								aria-label="Go to programs page"
								className="mt-3 me-2 btn-sm"
							>
								Learn more
							</Button>
						</Col>
						<Col lg={4} className="mb-5">
							<h3 className="h6">Exam voucher</h3>
							<p className="mb-0">
								Cost of one exam voucher per course covered by
								ACI Learning after meeting{" "}
								<a
									href="https://help.acilearning.com/en/articles/8129302-voucher-release-process"
									target="_blank"
									rel="noopener noreferrer"
								>
									release requirements
								</a>
								.
							</p>
						</Col>
					</Row>
				</Container>
			</Section>
			<Section data={scheduleSectionData}>{renderCourseCatalog}</Section>

			<Section>
				<TwoColumnImageExtended data={nationalAcademyData} />
			</Section>

			<Section data={reviewSectionData}>
				<Container>
					<Introduction data={reviewIntroData} />
					<Row className="mt-5">{renderReviews}</Row>
				</Container>
			</Section>
			<Section data={ctaSectionData}>
				<TwoColumnImageExtended data={ctaData} />
			</Section>
		</Page>
	);
};

function TANameFormatter(location: string): string {
	switch (location) {
		case "CUSS":
			return "Computer User Support Specialist";
		case "ISA":
			return "Information Security Analyst";
		case "ITSS":
			return "IT Support Specialist";
		case "NSS":
			return "Network Support Specialist";
		case "NT":
			return "Network Technician";
		case "CA":
			return "Cybersecurity Analyst";
		case "STPM":
		default:
			return "Senior Technology Project Manager";
	}
}

function TANametoHref(location: string): string {
	switch (location) {
		case "CUSS":
			return "/itil-comptia-computer-user-support-specialist-cuss/";
		case "ISA":
			return "/information-security-analyst-isa/";
		case "ITSS":
			return "/it-support-specialist-program/";
		case "NSS":
			return "/network-support-specialist-nss/";
		case "NT":
			return "/network-technician-program/";
		case "CA":
			return "/cybersecurity-analyst-csa/";
		case "STPM":
		default:
			return "/senior-technology-project-manager-stpm/";
	}
}

function slugToName(slug: string): string {
	switch (slug) {
		case "it-training-near-me-dallas":
			return "Dallas";
		case "it-training-near-me-colorado-springs":
			return "Colorado Springs";
		case "it-training-near-me-san-antonio":
			return "San Antonio";
		case "online-it-training":
		default:
			return "National Online";
	}
}

function renderTimeIcon(time: string): ReactNode {
	switch (time) {
		case "8 am":
			return <MorningIcon />;
		case "1 pm":
			return <AfternoonIcon />;
		case "6 pm":
		default:
			return <NightIcon />;
	}
}

/** Exports */

export default HubPage;

/** GraphQL */

export const Query = graphql`
	query HubPage($pageId: String) {
		queryData: strapiHub(id: { eq: $pageId }) {
			id
			slug
			heroData {
				...TwoColumnImageExtended
			}
			galleryData {
				...MultiColumnImage
			}
			mapData {
				...TwoColumnMapiFrame
			}
			SEO {
				...SEO
			}
		}
	}
`;

/** Page Metadata */

export const Head: HeadFC<Queries.HubPageQuery> = ({ data }) => (
	<SEO data={data.queryData?.SEO} />
);
